// components/filtv/useFiltvChannels.js
import { useMemo } from "react";
import useFetch from "./useFetch";
import { channels as demoChannels, advertisements as demoAds } from "./filtvDemoData";
import { FILTV_CHANNELS_URL, FILTV_AD_AVAILABILITY_URL } from "./filtvConstants";
import { buildChannelAvailability } from "./filtvHelpers";

export default function useFiltvChannels() {
    const { data: channelsData, loading: channelsLoading, error: channelsError } =
        useFetch(FILTV_CHANNELS_URL);
    const { data: availabilityData, loading: availabilityLoading } =
        useFetch(FILTV_AD_AVAILABILITY_URL);

    const baseChannels = useMemo(
        () => (Array.isArray(channelsData) && channelsData.length ? channelsData : demoChannels),
        [channelsData]
    );

    const channels = useMemo(() => {
        if (Array.isArray(availabilityData?.lcns)) {
            const liveLcns = new Set(availabilityData.lcns);
            return baseChannels.map((c) => ({ ...c, hasAd: liveLcns.has(c.lcn) }));
        }
        return buildChannelAvailability(baseChannels, demoAds);
    }, [baseChannels, availabilityData]);

    return {
        channels,
        loading: channelsLoading || availabilityLoading,
        error: channelsError,
        usingDemoData: !Array.isArray(channelsData) || !channelsData.length,
    };
}